import { useEffect } from 'react';
import { extent, max } from 'd3-array';
import { axisBottom, axisLeft } from 'd3-axis';
import { scaleLinear, scaleTime } from 'd3-scale';
import { select } from 'd3-selection';
import { area, line } from 'd3-shape';
import { timeParse } from 'd3-time-format';
import { color, fontSize } from '@ifixit/primitives';

interface RepData {
   date: number;
   rep: number;
}

type AreaProps = {
   graphData: RepData[];
   margin?: { top: number; right: number; bottom: number; left: number };
};

const Graph = ({ graphData, margin = { top: 20, right: 20, bottom: 30, left: 65 } }: AreaProps) => {
   const createGraph = (parentWidth: number, parentHeight: number) => {
      const parseTime = timeParse('%Q');

      const data = graphData.map((d: RepData) => ({
         date: parseTime(d.date.toString()),
         rep: d.rep,
      }));

      const width = parentWidth - margin.left - margin.right;
      const height = parentHeight - margin.top - margin.bottom;

      const svg = select('svg.reputation-graph')
         .attr('width', width + margin.left + margin.right)
         .attr('height', height + margin.top + margin.bottom)
         .append('g')
         .attr('transform', `translate(${margin.left}, ${margin.top})`);

      // add X axis and Y axis
      const x = scaleTime().range([0, width]);
      const y = scaleLinear().range([height, 0]);

      // @ts-expect-error TS(2345) FIXME: Argument of type '[undefined, undefined] | [Date, ... Remove this comment to see the full error message
      x.domain(extent(data, d => d.date));
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      y.domain([0, max(data, d => d.rep) + height / 3]).nice();

      const xAxis = axisBottom(x)
         .ticks(width / 100)
         .tickSizeOuter(0);
      const yAxis = axisLeft(y)
         .ticks(height / 60)
         .tickSizeOuter(0);

      svg.append('g')
         .attr('transform', `translate(0, ${height})`)
         .call(xAxis)
         .style('font-size', fontSize.sm);

      svg.append('g').call(yAxis).style('font-size', fontSize.sm);

      const areaUnderLine = area()
         .x((d: any) => x(d.date))
         .y0(height)
         .y1((d: any) => y(d.rep));

      svg.append('path')
         .attr('fill', color.brand[200])
         .attr('fill-opacity', 0.7)
         .attr('d', areaUnderLine(data as any));

      const valueLine = line()
         .x((d: any) => x(d.date))
         .y((d: any) => y(d.rep));

      svg.append('path')
         .attr('fill', 'none')
         .attr('stroke', color.brand[500])
         .attr('stroke-width', 1.5)
         .attr('d', valueLine(data as any));
   };

   useEffect(() => {
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      const parent = document.querySelector('.reputation-graph').parentElement;
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      createGraph(parent.offsetWidth, parent.offsetHeight);
   }, []);

   return <svg className="reputation-graph"></svg>;
};

export default Graph;
